<template>
  <b-col
    v-if="displaySideTabs"
    id="sidetabsContainer"
    ref="sidetabs"
    class="px-0 mh-100"
    :style="{'overflow': 'hidden'}"
    :cols="cols"
    :class="{'flex-grow-1': cols==='3'}"
  >
    <transition-group name="tab-list">
      <template v-for="tab of visibleTabs">
        <SideTab
          :key="`tab-${tab.secondaryAppPath || tab.nodeType}-${tab.path}`"
          :details="tab"
          :data-test="`tab-${tab.path}`"
        />
      </template>
    </transition-group>
  </b-col>
</template>

<script lang="ts">

import Vue from 'vue'
import Component from 'vue-class-component'

import SideTab from '@/components/public/SideTabs/SideTab.vue'

import { NodeTypes, Tab } from '@/types'

const components = {
  SideTab,
}

const props = {
  cols: {
    type: String,
    default: 'auto',
  },
  disableShadow: Boolean,
}

@Component({ components })
export default class SideTabs extends Vue.extend({ props }) {
  get displaySideTabs () {
    return this.visibleTabs.length > 1
  }

  get visibleTabs () {
    return this.$typedStore.primary.entities.tabs.visibleTabs
  }

  displaySubtabs (tab: Tab) {
    return tab.nodeType === NodeTypes.APP &&
    tab.path === this.$typedStore.public.display.activeTab?.path
  }
}

</script>

<style lang="scss" scoped>

@import '@/components/public/SideTabs/tabs.scss';
#sidetabsContainer {
  z-index: 1;
}

#sidetabsContainer:has(.vertical-tab) {
  width: 10%;
}

#sidetabsContainer:has(.horizontal-tab) {
  max-width: 20%;
}

</style>
